// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO: Find a way to make jqxDataTable use its own sizing in containers with position:relative */
.TableViewRenderer {
    height: 100%;
}
.TableViewRenderer td {
    vertical-align: top;
}
.TableViewRenderer .jqx-grid-cell {
    padding: 0;
}
.TableViewRenderer .jqx-grid {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.TableViewRenderer .content {
    position: relative;
}
.TableViewRenderer .jqx-grid {
    box-sizing: border-box;
    max-height: 100%;
    max-width: 100%;
}
.TableViewRenderer td .cell-content {
    height: 100%;
    display: block;
    padding: 5px;
    /*setting width + padding  = 100% so when setting column.key.cellAlign: right the cell looks right*/
    width: calc(100% - 10px);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
